export default __webpack_public_path__ + "static/media/no_positions.6fae1126.svg";